import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FORGOT_PASSWORD, CREATE_ACCOUNT } from "../../../constants";
import { TextInput } from "../../../commons/formik";
import { Button } from "../../../commons/elements/index";
import "../styles/login.scss";

const propTypes = {
  clientId: PropTypes.number.isRequired,
  handleLogin: PropTypes.func.isRequired,
  // Map state to props
  nextUrl: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired
};

function LoginForm(props) {
  const { clientId, nextUrl, isSubmitting, handleLogin } = props;
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const { shortName: clientUsername } = params;

  const initialValues = {
    email: "",
    password: ""
  };

  const LoginFormSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Please enter your email"),
    password: Yup.string().required("Please enter your password")
  });

  const handleSubmit = (values) => {
    handleLogin({
      ...values,
      clientId,
      history,
      nextUrl,
      shortName: clientUsername
    });
  };

  const goToCreateAccount = () => {
    history.push(`/${clientUsername}/${CREATE_ACCOUNT}${location.search}`);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={LoginFormSchema}
      onSubmit={handleSubmit}
    >
      {({ isValid }) => (
        <Form className="mr-0 pb-0 mx-0">
          <TextInput
            id="create-account-email"
            label="Email"
            placeholder="example@email.com"
            name="email"
            type="text"
            labelProps={{ className: "lbl-email" }}
          />
          <TextInput
            id="create-account-password"
            label="Password"
            placeholder="password"
            name="password"
            type="password"
            labelProps={{ className: "lbl-password" }}
          />
          <Button
            className="mt-3"
            type="submit"
            label="Sign In"
            disabled={!isValid || isSubmitting}
            isSubmitting={isSubmitting}
          />
          <div className="py-3">
            <Link
              className="forgot-password"
              to={`/${clientUsername}/${FORGOT_PASSWORD}${location.search}`}
            >
              Forgot password?
            </Link>
          </div>
          <span>Don&apos;t have an account?</span>
          <Button
            className="mt-3"
            label="Create Account"
            onClick={goToCreateAccount}
          />
        </Form>
      )}
    </Formik>
  );
}

LoginForm.propTypes = propTypes;

const mapStateToProps = (state) => ({
  nextUrl: state.user.nextUrl,
  isSubmitting: state.user.isSubmitting
});

export default connect(mapStateToProps)(LoginForm);
